import React, { Component } from 'react'
import List from '../components/Reisadviezen/List'
import dynamicPortal from '../utils/dynamicPortal';

export class ReisadviezenPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-reisadviezen', (config) => (
      <List config={config} />
    ))
  }
}

export default ReisadviezenPortal



// WEBPACK FOOTER //
// ./src/portals/ReisadviezenPortal.js